import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const TreatmentsAvailable = () => {
  const [treatments, setTreatments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTreatments();
  }, []);

  const fetchTreatments = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Use direct API call like other components in the project
      const response = await fetch('https://medical-linkers.onrender.com/api/treatments?status=published&limit');
      const data = await response.json();
      
      if (data.treatments) {
        setTreatments(data.treatments);
      } else {
        setTreatments([]);
      }
    } catch (error) {
      console.error('Error fetching treatments:', error);
      setError('Failed to load treatments');
      setTreatments([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="flex justify-center items-center px-4 py-10 bg-white">
        <div className="max-w-7xl w-full">
          <h2 className="text-3xl font-bold text-center mb-10">
            <span className="text-blue-600">Treatments</span> Available
          </h2>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="flex justify-center items-center px-4 py-10 bg-white">
        <div className="max-w-7xl w-full">
          <h2 className="text-3xl font-bold text-center mb-10">
            <span className="text-blue-600">Treatments</span> Available
          </h2>
          <p className="text-center text-red-600">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="flex justify-center items-center px-4 py-10 bg-white">
      <div className="max-w-7xl w-full">
        <h2 className="text-3xl font-bold text-center mb-10">
          <span className="text-blue-600">Treatments</span> Available
        </h2>

        {/* Treatment Grid */}
        <div className="grid grid-cols-3 gap-y-8 gap-x-8 text-lg font-semibold text-gray-900 justify-items-center">
          {treatments.map((treatment) => (
            <Link
              key={treatment.id}
              to={`/treatments/${treatment.slug}`}
              className="hover:text-blue-600 transition-colors duration-200 text-center"
            >
              {treatment.title}
            </Link>
          ))}
        </div>

        {/* Show message if no treatments */}
        {treatments.length === 0 && !loading && !error && (
          <div className="text-center text-gray-600">
            No treatments available at the moment.
          </div>
        )}
      </div>
    </section>
  );
};

export default TreatmentsAvailable;
